module.exports = __webpack_public_path__ + "static/semantic-select-loading-b8c76fbd721ee4c5c8641b1d8b03b7e6.gif";